<template>
  <div>
    <div class="footer drRtl">
      <!-- 
      <img class="smoke" src="../../assets/images/smoke.gif" alt="">
      <img class="smoke1" src="../../assets/images/smoke1.gif" alt=""> -->

      <div class="footer__box w margin">
        <div v-if="$root.globalData" class="footer__item item1">
          <h1 class="logo">
            <router-link to="/"> <img width="100px" :src="'https://gorgon.ir/storage/' +
                  $root.globalData.settings.logo_pages" alt="logo" /> </router-link>
          </h1>
          <p class="desc" v-if="$root.globalData">
            {{ $root.globalData.keys.footer_text }}
          </p>
          <p class="phone">
            <!-- <span> {{  $root.globalData.settings.footer_phone  }} </span> <TelIcon /> -->
          </p>

          <div class="socials">
            <Telegram /> <Instagram /> <Whatsapp /> <Twitter />
          </div>
        </div>

        <div v-if="$root.globalData" class="footer__item item2">
          <div class="lists">
            <div class="listbox1">
              <ul class="lists">
                <li
                  class="list__item"
                  v-for="(item, index) in $root.globalData.menus.footer"
                  :key="index"
                >
                  <router-link
                    class="responsive__items"
                    v-if="item.linkable_type != null"
                    :to="
                      findUrl(item.linkable_type, item.linkable_id, item.slug)
                    "
                  >
                    {{ item.title }}
                  </router-link>
                  <a v-else class="responsive__items2" :href="item.link">
                    {{ item.title }}
                  </a>
                </li>
              </ul>

           
            </div>
          </div>
        </div>

        <!-- item3 -->

        <div v-if="$root.globalData" class="footer__item item3">
          <p class="logintext">{{ $root.globalData.keys.newsletter_text }}</p>

          <div class="search">
            <form class="formlogin" @submit.prevent="joinNewsletter()">
              <input
                type="text"
                name=""
                id=""
                v-model="newsletter"
                :placeholder="$root.globalData.keys.newsletter_placeholder"
              />
              <input
                type="submit"
                :value="$root.globalData.keys.newsletter_button"
              />
            </form>
          </div>

          <div class="labtop">
            <img :src="labtop" alt="labtop" />
          </div>
        </div>
      </div>
      <div class="copyright w margin">
        <p>{{ copyrightrightbox }}</p>
        <p>
          Copyright 2021 inYab Designed By
          <a href="https://shetabit.com/" target="_blank"> shetabit</a> | All
          rights reserved
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import findUrl from "@/assets/links/LinkResolver.js";

import Logo from "../../assets/images/FooterLogoPng.png";
import TelIcon from "../svgs/TelIcon.vue";
import Telegram from "../svgs/Telegram.vue";
import Instagram from "../svgs/Instagram.vue";
import Whatsapp from "../svgs/Whatsapp.vue";
import Twitter from "../svgs/Twitter.vue";
import Labtop from "../../assets/images/labtopgif.gif";
export default {
  data() {
    return {
      newsletter: "",
      labtop: Labtop,
      logo: Logo,
      item1text:
        " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است ",
      phone1: " ۰۹۱۱۴۰۸۸۳۷۶ ",
      phone2: " ۰۹۱۱۴۰۸۸۳۷۶ ",
      listbox1: ["آلمینیوم", "نولیدی ماسک", "آلمینیوم", "لبنیات"],
      listbox2: ["آق قلا", "کردکوی", "علی آباد", "گنبد"],

      item3text:
        "جهت اطلاع از آخرین اخبار و اطلاعیه ها در خبرنامه ما عضو شوید ",

      copyrightrightbox:
        ".کلیه حقوق سایت به inYab  تعلق دارد و کپی برداری از آن ممنوع می باشد "
    };
  },
  methods: {
    findUrl,
    ValidateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      }
      return false;
    },
    joinNewsletter() {
      if (!this.ValidateEmail(this.newsletter)) {
        this.$toast.warning(
          this.$root.globalData?this.$root.globalData.keys.please_enter_an_email_in_the_correct_format_text:""
        );
      } else {
        const formData = new FormData();
        formData.append("email", this.newsletter);
        this.newsletter = "";
        this.$axios.post("front/subscribe", formData).then((res) => {
          this.$toast.success(
            
                       this.$root.globalData?this.$root.globalData.keys.not_found_any_blog_for_your_request_text:""

          );
        });
      }
    }
  },
  components: { TelIcon, Telegram, Instagram, Whatsapp, Twitter }
};
</script>

<style scoped>
.footer {
  width: 100%;
  background-image: url(../../assets/images/footerbg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 1rem 0;
  position: relative;
}

.smoke {
  width: 150px;
  position: absolute;
  right: 35.5%;
  top: 23%;
  opacity: 0.2;
  opacity: 0.2;
}
.smoke1 {
  width: 150px;
  position: absolute;
  top: 7%;
  left: 41%;
  opacity: 0.2;
}

.footer__box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  margin-bottom: 1rem;
  border-bottom: 2px solid #666;
  padding-top: 3rem;
}
@media (max-width: 768px) {
  .footer__box {
    display: flex;
    align-items: center;
    grid-template-columns: unset;
    flex-direction: column-reverse;
  }
}
.footer__item {
  padding: 0 1rem;
  text-align: justify;
}

.item1,
.item2 {
  text-align: right;
}

.item2 {
  margin-right: 1rem;
}
@media (max-width: 768px) {
  .item2 {
    width: 100%;
    margin: 10px 0;
  }
}
.item2 a {
  color: black;
}
.item2 p {
  font-size: 18px;
  font-weight: bold;
}

.item1 {
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
}
.item1 .logo,
.desc,
.phone,
.social {
  margin-bottom: 1rem;
}
.item1 p {
  font-size: 14px;
  line-height: 3;
  text-align: justify;
}

.phone {
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone span {
  font-size: 18px;
  padding: 0 10px;
}
.socials {
  display: flex;
  justify-content: center;
}
.listbox1 {
  display: flex;
  justify-content: space-between;
}
.list__item {
  padding: 10px 0;
  list-style-type: disc;
  font-size: 14px;
}
.item3 {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.logintext {
  font-size: 14px;
  margin-bottom: 2rem;
  font-weight: bold;
}
.search {
  background-color: #c8c8c8;
  border-radius: 30px;
}
.formlogin {
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  background-color: #9c9c9c91;
  padding: 5px;
}

.formlogin input {
  padding: 10px;
  border-radius: 20px;
}
.formlogin input:first-child {
  display: flex;
  width: 100%;
  background-color: transparent;
  color: #000;
  outline: none;
  flex-wrap: wrap;
}
.formlogin input:last-child {
  background-color: grey;
  color: #fff;
  padding: 10px 30px;
}
.labtop {
  filter: grayscale(10);
}
.labtop img {
  height: 350px;
}
.copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
@media only screen and (max-width: 768px) {
  .labtop {
    display: none;
    justify-content: center;
  }
}
@media only screen and (max-width: 460px) {
  .item3 {
    text-align: center !important;
  }
}
</style>
<style>
.ltrStyle .item1 p,
.ltrStyle .logintext {
  direction: ltr;
}
.ltrStyle .phone {
  justify-content: flex-start;
}
</style>
